import FormField from 'lib/src/components/form/FormField';
import { DropdownOption } from 'lib/src/types/shared/DropdownOption';
import { FormInputProps } from 'lib/src/types/shared/FormInputProps';
import React, { SyntheticEvent, useCallback } from 'react';
import useFieldValidation from './hooks/useFieldValidation';

const Slider: React.FC<RangeInputProps> = ({
    name,
    value,
    onChange,
    label = '',
    required = false,
    min = 0,
    max = 100,
    step = 1,
    disabled,
    customValidate,
    fieldClassName,
    forceAsterisk = false,
    stepMarkers,
}) => {
    const [error, showError] = useFieldValidation({
        name,
        required,
        value,
        customValidate,
    });
    const scoreClass = value < 0.2 ? 2 : value < 0.4 ? 3 : value < 0.6 ? 4 : 5;
    return (
        <FormField
            name={name}
            label={label}
            required={required}
            error={error}
            className={fieldClassName}
            forceAsterisk={forceAsterisk}
        >
            <p style={{ textAlign: 'center' }}>{Math.round(value * 100)}%</p>

            <input
                type="range"
                className={`form-input assessment-slider ${
                    error ? 'error' : ''
                } score-${scoreClass}`}
                name={name}
                id={name}
                min={min}
                max={max}
                step={step}
                value={value}
                onChange={handleChange}
                onBlur={handleBlur}
                disabled={disabled}
            />

            <div className="assessment-slider-ratings flex-row justify-between">
                {stepMarkers?.map(({ label, value }) => (
                    <p onClick={() => onChange(name, value)}>{label}</p>
                ))}
            </div>
        </FormField>
    );

    function handleBlur() {
        showError();
    }

    function handleChange(e: SyntheticEvent) {
        e.preventDefault();
        const newVal = +(e.target as HTMLInputElement).value;
        onChange(name, newVal);
    }
};

interface RangeInputProps extends FormInputProps<number> {
    label?: string;
    min?: number;
    max?: number;
    step?: number;
    fieldClassName?: string;
    forceAsterisk?: boolean;
    stepMarkers?: DropdownOption<number>[];
}

export default Slider;
